import React, { useEffect } from 'react'
import { useState } from "react";

import { makeStyles, withStyles } from '@material-ui/core/styles';

import LoadingComponent from '../../../components/Loading';

import { useSelector } from "react-redux";

import {
    selectUsuarioSeleccionado,
} from "../../../redux/reducer/loginReducer";
import EmptyComponent from '../../../components/EmptyContent';
// import { deleteInquilino, getAlumnos, inquilinoDelete } from '../../../../services/Alumnos';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from '@material-ui/core';
import { DataGrid, GridActionsCellItem, GridToolbarDensitySelector, GridToolbarFilterButton} from '@mui/x-data-grid';
import EditIcon from '@material-ui/icons/Edit';
import SyncIcon from '@material-ui/icons/Sync';
import Swal from 'sweetalert2';
import { Link, useHistory } from 'react-router-dom';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import TituloPagina from '../../../components/Titulos/TituloPagina';
import AddIcon from '@material-ui/icons/Add';
import { dudaInternaMarcarReenviar, dudaInternaMarcarResuelta, getAlumnos, getAvisosUsuario, getDudasInternas, update_comercial } from '../../../services/alumnos';
import { Stack, width } from '@mui/system';
import {sincronizar_formularios, sincronizar_notion, sincronizar_woo_order} from '../../../services/sincronizar'
import { getComerciales } from '../../../services/comerciales';
import { getCuotasMes, getFacturas, getProximasCuotas } from '../../../services/cuotas';
import Moment from 'react-moment';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { actualizar_factura_alumno_producto_cuota } from '../../../services/alumnos_productos_cuotas';
import { DataGridPro } from '@mui/x-data-grid-pro';
import DataGridInnovattio from '../../../components/DataGridInnovatiio';
import moment from 'moment';
import SendIcon from '@material-ui/icons/Send';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import useDataGridFilterPersist from '../../../hooks/useDataGridFilterPersist';

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

// import Moment from 'react-moment';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '80px'
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh"
    },
    emptyContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        width: '100%',
        flexDirection: 'column',
        textAlign: 'center'
    },
    emptyImage: {
        width: '100%'
    },
    rootFilter: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      },
    textFieldFilter: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
        margin: theme.spacing(1, 0.5, 1.5),
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(0.5),
        },
        '& .MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    enlace: {
      color: theme.palette.link.main,
      textDecoration: 'none'
    }
}));

export default function IncidenciasContent() {
    const classes = useStyles();

    const [dudas, setDudas] = useState([]);
    const [loading, setLoading] = useState(false)
    const [loadingMensaje, setLoadingMensaje] = useState("")

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });
    // const history = useHistory()

    /* -------------------------------------------------------------------------- */
    /*                                  UseEffect                                 */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true)
        setLoadingMensaje("Cargando dudas internas...")

        const usuario_id = usuarioSeleccionado.id

        fetchDudas()
      
    }, [])

    const fetchDudas = () => {
        setLoading(true)
        setLoadingMensaje("Cargando dudas internas...")

        const usuario_id = usuarioSeleccionado.id

        getDudasInternas({usuario_id}).then ( (response) => {
            response && setDudas(response.resultado)
            setLoading(false)
            setLoadingMensaje(false)
        })
    }

    /* -------------------------------------------------------------------------- */
    /*                           Definicion de columnas                           */
    /* -------------------------------------------------------------------------- */
    const OperacionMarcarResuelta = (params) => (
        <GridActionsCellItem
                icon={<PlaylistAddCheckIcon />}
                label="Marcar como resuelto"
                onClick={() => {
                    Swal.fire({
                        title: '¿Estás seguro?',
                        text: "La incidencia se marcará como resuelta",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sí, marcar como resuelta'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            dudaInternaMarcarResuelta({duda_interna_id: params.params.id, usuario_id: usuarioSeleccionado.id}).then( (response) => {
                                    Swal.fire(
                                        '¡Hecho!',
                                        'La incidencia se ha marcado como resuelta.',
                                        'success'
                                    )
                                    fetchDudas()
                            })
                        }
                    })
                }}
                showInMenu
            />
    )
    const OperacionMarcarReenviar = (params) => (
        <GridActionsCellItem
                icon={<SendIcon />}
                label="Reenviar a..."
                onClick={() => {
                    console.log(params,params.id)
                    Swal.fire({
                        title: '¿Estás seguro?',
                        text: "La incidencia se reenviará en función de la categoría",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sí, reenviar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            dudaInternaMarcarReenviar({duda_interna_id: params.params.id, usuario_id: usuarioSeleccionado.id}).then( (response) => {
                                    Swal.fire(
                                        '¡Hecho!',
                                        'La incidencia se ha reenviado.',
                                        'success'
                                    )
                                    fetchDudas()
                            })

                        }
                    })
                }}
                showInMenu
            />
    )
    const columnas = [
        {
            field: 'actions',
            type: 'actions',
            width: 80,
            getActions: (params) => {
                return usuarioSeleccionado.perfil_id === "1" ? [
                    OperacionMarcarResuelta({ params }),
                    OperacionMarcarReenviar({ params })
                ] : [
                    OperacionMarcarResuelta({ params })
                ];
            },
        },
        { field: 'id', hide: true, headerName: 'ID' },
        { field: 'categoria_nombre', headerName: 'Categoria', width:250},
        { field: 'asunto', headerName: 'Asunto', flex:1},
        { field: 'descripcion', headerName: 'Descripcion', flex:1},
        { field: 'url_origen', headerName: 'URL de Origen', width:400},
        { field: 'reenviado_a', headerName: 'Reenviado A', width:300},
        { field: 'creador_nombre', headerName: 'Creador', width:190},
        { field: 'alumno_id', headerName: 'Alumno ID', width:190},
        {
            field: "created",
            headerName: "Creada",
            minWidth: 150,
            type: "date",
            valueFormatter: params => 
            moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
            renderCell: (cellValues) => {
                return cellValues.value !== null &&
                cellValues.value !== "0000-00-00 00:00:00" ? (
                <Moment format="DD/MM/YYYY HH:mm:ss">{cellValues.value}</Moment>
                ) : (
                <></>
                );
            },
        },
        {
            field: "fecha_resuelto",
            headerName: "Fecha Resuelto",
            minWidth: 150,
            type: "date",
            valueFormatter: params => 
            moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
            renderCell: (cellValues) => {
                return cellValues.value !== null &&
                cellValues.value !== "0000-00-00 00:00:00" ? (
                <Moment format="DD/MM/YYYY HH:mm:ss">{cellValues.value}</Moment>
                ) : (
                <></>
                );
            },
        }
    ];

    /* -------------------------------------------------------------------------- */
    /*                                  Contenido                                 */
    /* -------------------------------------------------------------------------- */


function QuickSearchToolbar(props) {
        const classes = useStyles();
      
        return (
          <div className={classes.rootFilter}>
            <div>
              <GridToolbarFilterButton />
              {/* <GridToolbarDensitySelector /> */}
            </div>
            <TextField
              variant="standard"
              value={props.value}
              onChange={props.onChange}
              placeholder="Buscar…"
              className={classes.textFieldFilter}
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                  <IconButton
                    title="Clear"
                    aria-label="Clear"
                    size="small"
                    style={{ visibility: props.value ? 'visible' : 'hidden' }}
                    onClick={props.clearSearch}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </div>
        );
      }
      
      QuickSearchToolbar.propTypes = {
        clearSearch: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired,
      };

    const Contenido = () => {

        // const handleAlumnoDetalle = (id) => {
        //   history.push('alumnos/detalle/' + id )
        // }
    const [filterModel, onFilterModelChange] = useDataGridFilterPersist('incidencias_page','incidencias')

        return (
                <>
                    <TituloPagina titulo={"Incidencias"} />

                    
                    <div style={{ height: 500, width: '100%', padding:"0 15px" }}>
                        <DataGridInnovattio
                            rows={dudas} 
                            columns={columnas} 
                            rowHeight={30}
                            components={{ Toolbar: QuickSearchToolbar }}
                            // componentsProps={{
                            //     toolbar: {
                            //       value: searchText,
                            //       onChange: (event) => requestSearch(event.target.value),
                            //       clearSearch: () => requestSearch(''),
                            //     },
                            // }}
                            filterModel={ filterModel }
                            onFilterModelChange={ onFilterModelChange }
                        />

                    </div>
                    
                    {/* <Typography variant='caption' style={{marginTop: 10, marginLeft: 16}}>NOTA: Ordenado por fecha de entrada de gasto decreciente</Typography> */}

                </>
                
        )
    }
    
    /* -------------------------------------------------------------------------- */
    /*                                   Return                                   */
    /* -------------------------------------------------------------------------- */
    return (
        <div className={classes.container}>
            {
                (loading ?
                    
                    <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
                    
                    :
                    
                    <Contenido />
                )
            }
        </div>
    )
}
